import { styled } from "../../../styled-components";

export const LargeTitleStyle = styled.div`
    ${p => p.theme.fontStyles.AccentHeader1}

    line-height: 41px;

    display: flex;
    align-items: center;

    padding-left: ${p => p.theme.pageMarginMedium}px;

    color: ${p => p.theme.navBar.titleColor};
`;

export const Container = styled.div`
    overflow: hidden;
    margin-top: ${p => p.theme.navBar.height}px;

    & ${LargeTitleStyle} {
        width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: block;
    }
`;
export const Wrapper = styled.div<{ translateAmount: number }>`
    display: flex;
    flex-direction: column;

    align-items: stretch;

    transform: translateY(${p => p.translateAmount}px);

    pointer-events: auto;
`;

export const CollapserStyle = styled.div`
    display: flex;

    width: 100%;
    height: ${p => p.theme.navBar.largeTitleHeight}px;

    overflow: hidden;
`;
